import React, { useState } from "react";
import { Navbar, Input, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Button, Row, Col, Modal, ModalBody, ModalHeader, Label, FormGroup, Alert } from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import { logout } from "../Utilities/Auth";
import Navigation from "./Navigation";
import logo from "../Assets/images/logo.png"
import "../Assets/css/--layout.css";
import { updatePassword } from "../API/Backend";
import { showToast } from "../Components/Toast"
import { ToastContainer } from "react-toastify";

export default function AdminLayout(props) {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [repeatPassword, setRepeatPassword] = useState("");
  const [showPassword, setShowPassword] = useState({ oldPassword: false, newPassword: false, repeatPassword: false });
  const [errors, setErrors] = useState({ oldPassword: "", newPassword: "", repeatPassword: "", apiError: "" });
  const [loading, setLoading] = useState(false);

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);
  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

  const suggestions = [
    { name: "Products", url: "/products" },
    { name: "Users", url: "/users" },
    { name: "Banners", url: "/banners" },
    { name: "Add Banner", url: "/banners/add" },
  ];


  const [query, setQuery] = useState("");
  const [filtered, setFiltered] = useState([]);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const value = e.target.value;
    setQuery(value);

    if (value.trim()) {
      const results = suggestions.filter(s =>
        s.name.toLowerCase().includes(value.toLowerCase())
      );
      setFiltered(results);
    } else {
      setFiltered([]);
    }
  };

  const handleSelect = (url) => {
    navigate(url);
    setQuery("");
    setFiltered([]);
  };

  const validateSubmit = (e) => {
    e.preventDefault();
    const error = { oldPassword: "", newPassword: "", repeatPassword: "", apiError: "" }
    let flag = false;
    if (!newPassword || newPassword.replaceAll(/\s/g, '').length < 6) {
      error.newPassword = 'Please provide a new password';
      flag = true
    }
    if (repeatPassword !== newPassword) {
      error.repeatPassword = 'Password does not match';
      flag = true
    }
    setErrors(error);
    console.log("flag", flag)
    if (!flag) {
      setLoading(true)
      updatePassword({ newPassword: newPassword }).then(({ data }) => {
        showToast("success", "Password Changed", "Your password has been changed successfully.")
        setLoading(false);
        setViewModal(false)
        setNewPassword("")
        setRepeatPassword("")
      }).catch((e) => {
        console.log(e)
        showToast("error", "Error", "Password could not be changed.")
        const error = { oldPassword: "", newPassword: "", repeatPassword: "", apiError: e.message }
        setErrors(error);
        setLoading(false)
      })
    }
  }



  return (
    <div className={`admin-layout ${sidebarOpen ? 'sidebar-open' : 'sidebar-closed'}`}>
      <aside className={`sidebar ${sidebarOpen ? 'open' : 'closed'}`}>
        <div className="sidebar-logo"><Link to="/dashboard" className="d-block py-1"><img src={logo} alt="logo" width={140} /></Link></div>
        <Navigation />
      </aside>
      <div className="main-content">
        <Navbar color="white" light className="topbar">
          <div className="d-flex">
            <Button color="link" className="hamburger" onClick={toggleSidebar} >
              <i className={sidebarOpen ? "ri-menu-2-fill" : "ri-menu-line"}></i>
            </Button>
            <div className="search-wrapper position-relative">
              <Input type="search" placeholder="Search..." value={query} onChange={handleChange} />
              {
                query ? 
                <i className="ri-close-circle-fill topbar-search-icon cursor-pointer fs-18" onClick={() => {setQuery(""); setFiltered([])}}></i>
                :
                <i className="ri-search-line topbar-search-icon"></i>
              }
              {filtered.length > 0 && (
                <ul className="search-dropdown position-absolute bg-white border rounded shadow-sm mt-1 w-100">
                  {filtered.map((item, index) => (
                    <li key={index} onClick={() => handleSelect(item.url)} className="px-3 py-2 d-flex justify-content-between align-items-center fw-400 cursor-pointer">
                      {item.name}
                      <i className="ri-arrow-right-line"></i>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>
          <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
            <DropdownToggle color="link" className="user-dropdown">
              <div className="user-avatar d-inline-flex align-items-center justify-content-center">
                <i className="ri-user-3-line fs-18"></i>
              </div>
            </DropdownToggle>
            <DropdownMenu end>
              <DropdownItem onClick={() => setViewModal(true)}>Update Password</DropdownItem>
              <DropdownItem divider />
              <DropdownItem onClick={logout}>Logout</DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </Navbar>
        <main className="page-content">
          {props.children}
          <Modal isOpen={viewModal} toggle={() => { setViewModal(false) }} centered={true} size='md'>
            <ModalHeader toggle={() => { setViewModal(false) }}>
              <small>Change Password</small>
            </ModalHeader>
            <ModalBody>
              <form onSubmit={validateSubmit}>
                <Row>
                  <Col md={12}>
                    {errors.apiError ? <Alert color="danger">{errors.apiError}</Alert> : null}

                    {/* <FormGroup className="position-relative">
                      <Label className='fw-600' for="oldPassword">Old Password</Label>
                      <Input type={showPassword.oldPassword ? "text" : "password"} id="oldPassword" value={oldPassword} onChange={(e) => { setOldPassword(e.target.value) }} placeholder="Enter your password" />
                      <i
                        className={`ri-${showPassword.oldPassword ? "eye-off" : "eye"}-line show-hide-password-icon`}
                        onClick={(e) => { setShowPassword((prev) => { return { ...prev, oldPassword: !showPassword.oldPassword } }); }}
                      ></i>
                      {errors.oldPassword ? <div className="invalid-feedback">{errors.oldPassword}</div> : null}
                    </FormGroup> */}
                    <div className="position-relative mb-1">
                      <Label className='fw-600' for="newPassword">New Password</Label>
                      <Input type={showPassword.newPassword ? "text" : "password"} id="newPassword" value={newPassword} onChange={(e) => { setNewPassword(e.target.value) }} placeholder="Enter your password" />
                      <i
                        className={`ri-${showPassword.newPassword ? "eye-off" : "eye"}-line show-hide-password-icon`}
                        onClick={(e) => { setShowPassword((prev) => { return { ...prev, newPassword: !showPassword.newPassword } }); }}
                      ></i>
                    </div>
                    {errors.newPassword ? <div className="invalid-feedback mb-2">{errors.newPassword}</div> : null}
                    <div className="position-relative mt-3">
                      <Label className='fw-600' for="repeatPassword">Repeat Password</Label>
                      <Input type={showPassword.repeatPassword ? "text" : "password"} id="repeatPassword" value={repeatPassword} onChange={(e) => { setRepeatPassword(e.target.value) }} placeholder="Enter your password" />
                      <i
                        className={`ri-${showPassword.repeatPassword ? "eye-off" : "eye"}-line show-hide-password-icon`}
                        onClick={(e) => { setShowPassword((prev) => { return { ...prev, repeatPassword: !showPassword.repeatPassword } }); }}
                      ></i>
                    </div>
                    {errors.repeatPassword ? <div className="invalid-feedback mb-2">{errors.repeatPassword}</div> : null}

                  </Col>
                  <Col md={12} className="text-center mt-4">
                    <button type="submit" disabled={loading} className="btn btn-primary me-2">{loading ? 'Please Wait' : 'Update Password'}</button>
                    <button type="button" className="btn btn-outline-primary mr-2" onClick={() => { setViewModal(false) }}>Close</button>
                  </Col>
                </Row>
              </form>
            </ModalBody>
          </Modal>
        </main>
        <ToastContainer />
      </div>
    </div>
  );
}